import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiHelper } from "../utils/apiHelper";

// Yatırımları getir
export const fetchInvestments = createAsyncThunk(
    'invest/fetchInvestments',
    async (startupId) => {
        try {
            const response = await ApiHelper.get(`/investment/${startupId}/investment`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (response.data.code === "00000") {
                return response.data.investment;
            } else {
                throw new Error(response.data.code);
            }
        } catch (error) {
            throw error;
        }
    }
);

export const fetchInvestmentDetail = createAsyncThunk(
    'invest/fetchInvestmentDetail',
    async (userId) => {
        try {
            const response = await ApiHelper.get(`/investment/${userId}/investment`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (response.data.code === "00000") {
                return response.data.investment;
            } else {
                throw new Error(response.data.code);
            }
        } catch (error) {
            throw error;
        }
    }
);

// Yeni yatırım oluştur
export const createInvestment = createAsyncThunk(
    'invest/createInvestment',
    async (investmentData) => {
        try {
            const response = await ApiHelper.post(
                `/investment/create`,
                {
                    startupId: investmentData.startupId,
                    paymentType: investmentData.paymentType,
                    paymentDetail: investmentData.paymentDetail,
                    amount: investmentData.amount,
                    status: investmentData.status
                },
                {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );
            if (response.data.code === "00000") {
                return response.data.investment;
            } else {
                throw new Error(response.data.code);
            }
        } catch (error) {
            throw error;
        }
    }
);

const investSlice = createSlice({
    name: 'invest',
    initialState: {
        payments: [],
        loading: false,
        error: null,
        createSuccess: false
    },
    reducers: {
        clearCreateSuccess: (state) => {
            state.createSuccess = false;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch cases
            .addCase(fetchInvestments.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInvestments.fulfilled, (state, action) => {
                state.loading = false;
                state.payments = action.payload;
            })
            .addCase(fetchInvestments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            // Create cases
            .addCase(createInvestment.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.createSuccess = false;
            })
            .addCase(createInvestment.fulfilled, (state, action) => {
                state.loading = false;
                state.payments.push(action.payload);
                state.createSuccess = true;
            })
            .addCase(createInvestment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                state.createSuccess = false;
            });
    }
});

export const { clearCreateSuccess } = investSlice.actions;
export default investSlice.reducer;
